import React, { useCallback, useEffect, useState } from 'react';
import { withStyles } from '@jpmuitk/theme';
import { ColumnLayout } from '@jpmuitk/column-layout';
import { Logo } from '@jpmuitk/logo';
import { getClientLogo, getProfilePalette } from '../../redux/clientActions';
import { useParams } from 'react-router-dom';
import LanguageSelector from './LanguageSelector';
import { CircularProgress } from '@jpmuitk/progress';

const SvsBanner = ({ accessToken, sessionToken, accountRegion }) => {

  const defaultBannerColor = '#936946';

  const [fileWrapper, setFileWrapper] = useState();
  const [clientBannerColor, setClientBannerColor] = useState(defaultBannerColor);
  const [useDefaultBranding, setUseDefaultBranding] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { clientId, programId, profileName } = useParams();

  useEffect(() => {
    const fetchClientLogo = async () => {
      setIsLoading(true);
      try {
        const response = await getClientLogo(accessToken, sessionToken);
        const prof = await getProfilePalette(accessToken, sessionToken);
        const fileWrapper = await response.json();
        const color = await prof.text();

        if (fileWrapper.resource.length < 1 || clientBannerColor.length < 1) {
          setUseDefaultBranding(true);
        } else {
          setClientBannerColor(color);
          setFileWrapper(fileWrapper);
        }
      } catch (error) {
        console.log('Got error rendering logo: ', error);
        setUseDefaultBranding(true);
        setClientBannerColor(defaultBannerColor);
      } finally {
        setIsLoading(false);
      }
    };
    fetchClientLogo();
  }, [clientId, programId, profileName]);

  return (
    <header style={{
      width: '100%',
      borderBottom: '3px solid' + (useDefaultBranding ? defaultBannerColor : clientBannerColor),
    }}>
      <ColumnLayout
        spacing={2}
        display="flex"
        alignContent="center"
        container
        justify="space-between"
      >
        <ColumnLayout item style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
          {isLoading ?
            <CircularProgress aria-label="Loading logo" showInfo={false} variant="indeterminate" size={'small'}
                              style={{ marginLeft: '10px' }} />
            : <ClientLogo useDefaultBranding={useDefaultBranding} fileWrapper={fileWrapper} />}
        </ColumnLayout>
        <ColumnLayout item>
          <LanguageSelector accountRegion={accountRegion} />
        </ColumnLayout>
      </ColumnLayout>
    </header>
  );
};

const ClientLogo = ({ useDefaultBranding, fileWrapper }) => {
  const renderClientLogo = useCallback(() => {
    if (fileWrapper) {
      let source = 'data:';
      source += fileWrapper.contentType;
      source += ';base64,';
      source += fileWrapper.resource;
      return (
        <div
          style={{
            width: '140px',
            height: '50px',
            padding: '2px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}>
          <img style={{
            objectFit: 'contain', maxWidth: '100%', maxHeight: '100%',
          }} src={source} alt={'BrandLogo'} />
        </div>
      );
    } else {
      return <Logo density={'low'} style={{ paddingLeft: '10px' }} />;
    }
  }, [fileWrapper]);

  return (
    <>
      {useDefaultBranding && <Logo density={'low'} style={{ paddingLeft: '10px' }} />}
      {!useDefaultBranding && renderClientLogo()}
    </>
  );
};

export default SvsBanner;
